<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
        <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row no-gutter justify-center items-center">
                        <div class="vx-col hidden lg:block lg:w-1/2">
                            <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto" />
                        </div>

                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
                            <div class="p-8 login-tabs-container">
                                <div class="vx-card__title mb-4">
                                    <h4 class="mb-4">로그인</h4>
                                    <p>메디람한방병원 환자관리 시스템</p>
                                </div>

                                <div>
                                    <vs-input
                                        name="userid"
                                        icon-no-border
                                        icon="icon icon-user"
                                        icon-pack="feather"
                                        label-placeholder="아이디"
                                        v-model="userid"
                                        class="w-full"
                                        v-on:keyup.enter="validateEnter"
                                    />
                                    <p v-if="idCheck == true" class="text-danger">{{ idCheckMsg }}</p>
                                    <vs-input
                                        type="password"
                                        name="userpwd"
                                        icon-no-border
                                        icon="icon icon-lock"
                                        icon-pack="feather"
                                        label-placeholder="패스워드"
                                        v-model="userpwd"
                                        class="w-full mt-6"
                                        v-on:keyup.enter="validateEnter"
                                    />
                                    <p v-if="loginCheck == true" class="text-danger">{{ loginCheckMsg }}</p>

                                    <!-- <div class="flex flex-wrap justify-between my-5">
                                        <vs-checkbox v-model="checkbox_remember_me" class="mb-3">Remember Me</vs-checkbox>
                                        <router-link to="">Forgot Password?</router-link>
                                    </div> -->
                                    <vs-button class="w-full mt-5" @click="login">Login</vs-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
import axiosClass from '@/../util/axiosClass';
import store from '@/store/store';
export default {
    data() {
        return {
            userid: '',
            userpwd: '',
            idCheck: false,
            idCheckMsg: '',
            pwdCheck: false,
            pwdCheckMsg: '',
            loginCheck: false,
            loginCheckMsg: '',
            checkbox_remember_me: false,
        };
    },

    methods: {
        validateEnter() {
            this.login();
        },
        async login() {
            this.idCheck = false;

            if (this.userid == false) {
                this.idCheck = true;
                this.idCheckMsg = '아이디를 입력해주세요';
                return;
            }

            if (this.userpwd == false) {
                this.userpwd = '';
                this.pwdCheck = true;
                this.pwdCheckMsg = '패스워드를 입력해주세요.';
                return;
            }

            const jsonData = {
                userid: this.userid,
                userpwd: this.userpwd,
            };

            try {
                const { data } = await axiosClass.post('/api/login', jsonData, true);
                // console.log(data.data['CD_LEVEL']);

                // console.log('data:' + data.success);

                if (data.success == false) {
                    console.log('check');
                    this.$vs.notify({
                        title: 'ERROR',
                        text: data.message,
                        color: 'danger',
                        position: 'center',
                        iconPack: 'feather',
                        icon: 'icon-check',
                    });
                }

                if (data.data['STATUS'] == 'N') {
                    this.$vs.notify({
                        title: 'ERROR',
                        text: '해당 정보로 로그인 할 수 없습니다(비활성화). 관리자에게 문의해주세요.',
                        color: 'danger',
                        position: 'center',
                        iconPack: 'feather',
                        icon: 'icon-check',
                    });
                    return;
                }

                if (data.data['CD_LEVEL'] == '99') {
                    this.$vs.notify({
                        title: 'ERROR',
                        text: '퇴사자 정보로 로그인 하셨습니다.재확인 후 로그인 바랍니다.',
                        color: 'danger',
                        position: 'center',
                        iconPack: 'feather',
                        icon: 'icon-check',
                    });
                } else {
                    const loginCheck = await this.$store.dispatch('loginUser', data);
                    console.log(store.getters.getTABSUM);
                    
                    if (store.getters.getTABSUM & 1) {
                        location.href = '/patient/list';
                    } else if (store.getters.getTABSUM & 2) {
                        location.href = '/ward/list';
                    } else if (store.getters.getTABSUM & 4) {
                        location.href = '/ward_status/list';
                    } else if (store.getters.getTABSUM & 8) {
                        location.href = '/doctor/list';
                    } else if (store.getters.getTABSUM & 16) {
                        location.href = '/cure/list';
                    } else if (store.getters.getTABSUM & 32) {
                        location.href = '/injection/list';
                    } else if (store.getters.getTABSUM & 64) {
                        location.href = '/remote/list';
                    } else if (store.getters.getTABSUM & 128) {
                        location.href = '/message/schedule';
                    } else if (store.getters.getTABSUM & 256) {
                        location.href = '/management/ward';
                    } else if (store.getters.getTABSUM & 512) {
                        location.href = '/meal/view';
                    } else if (store.getters.getTABSUM & 1024) {
                        location.href = '/cs/list';
                    } else if (store.getters.getTABSUM & 32768) {
                        location.href = '/treatment/list';
                    }
                    else {
                        location.href = '/patient/list';
                    }
                }
            } catch (e) {
                console.log(e);
                console.log('오류가 발생되었습니다.');
            }
        },
    },
};
</script>

<style lang="scss">
#page-login {
    .social-login-buttons {
        .bg-facebook {
            background-color: #1551b1;
        }
        .bg-twitter {
            background-color: #00aaff;
        }
        .bg-google {
            background-color: #4285f4;
        }
        .bg-github {
            background-color: #333;
        }
    }
}
</style>
